import { z, ZodType } from 'zod';

export type UuidResponse = {
	id: string;
};

export const uuidResponseSchema: ZodType<UuidResponse> = z.object({
	id: z.string(),
});
